module.exports = __webpack_public_path__ + "assets/5310163b71e74b56486b61f16f32cc00.svg";